export default __webpack_public_path__ + "static/media/5.6.55fc7813.jpg";